import React from "react";
import { Box, Grid } from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payment";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import PeopleOutline from "@mui/icons-material/PeopleOutline";

import InformationTile from "components/Shared/InformationTile";

const PaymentIntegrationBasicDetail = ({ paymentIntegrationDetail }) => {
  return (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={4}>
          <InformationTile
            icon={() => <PaymentIcon color="primary" />}
            title="Provider"
            subtitle={paymentIntegrationDetail?.providers ?? "N/A"}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <CheckCircleOutline color="primary" />}
            title="Is Active"
            subtitle={paymentIntegrationDetail?.isActive ? "Yes" : "No"}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <PeopleOutline color="primary" />}
            title="Added Users"
          >
            <ul>
              {paymentIntegrationDetail?.addedUser?.map((u) => (
                <li key={u?._id}>- {u?.name}</li>
              ))}
            </ul>
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentIntegrationBasicDetail;